import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import simpleHero from './simpleHero.js';
import largeHero from './largeHero.js';
import mediaSection from './mediaSection.js';
import keyFiguresSection from './keyFiguresSection.js';
import bigTitleSection from './bigTitleSection.js';
import programsListSection from './programsListSection.js';
import pictureAndContentSection from './pictureAndContentSection.js';
import latestNewsGridSection from './latestNewsGridSection.js';
import logoCarouselSection from './logoCarouselSection.js';
import stepListSection from './stepListSection.js';
import simpleDatalistSection from './simpleDatalistSection.js';
import imageGallerySection from './imageGallerySection.js';
import simpleContentSection from './simpleContentSection.js';
import reportsGridSection from './reportsGridSection.js';
import teamSection from './teamSection.js';
import callToActionCardsGridSection from './callToActionCardsGridSection.js';
import logoCardsGridSection from './logoCardsGridSection.js';
import simpleCardsListSection from './simpleCardsListSection.js';
import researchGroupListingSection from './researchGroupListingSection.js';
import articleListingSection from './articleListingSection.js';
import eventListingSection from './eventListingSection.js';
import jobListingSection from './jobListingSection.js';
import diseaseListingSection from './diseaseListingSection.js';
import profileListingSection from './profileListingSection.js';
import departmentsSection from './departmentsSection.js';
import researchPlatformListingSection from './researchPlatformListingSection.js';
import contactSection from './contactSection.js';
import dividerSection from './dividerSection.js';
import donationBoxSection from './donationBoxSection.js';
import imageActionCardsSection from './imageActionCardsSection.js';
import legacySimulatorSection from './legacySimulatorSection.js';
var schema = defineObject('internationalizedArrayPageSectionsValue', {
    value: {
        type: 'array',
        of: [
            {
                type: 'simpleHero'
            },
            {
                type: 'largeHero'
            },
            {
                type: 'mediaSection'
            },
            {
                type: 'keyFiguresSection'
            },
            {
                type: 'bigTitleSection'
            },
            {
                type: 'programsListSection'
            },
            {
                type: 'pictureAndContentSection'
            },
            {
                type: 'latestNewsGridSection'
            },
            {
                type: 'logoCarouselSection'
            },
            {
                type: 'stepListSection'
            },
            {
                type: 'simpleDatalistSection'
            },
            {
                type: 'imageGallerySection'
            },
            {
                type: 'simpleContentSection'
            },
            {
                type: 'teamSection'
            },
            {
                type: 'callToActionCardsGridSection'
            },
            {
                type: 'logoCardsGridSection'
            },
            {
                type: 'simpleCardsListSection'
            },
            {
                type: 'researchGroupListingSection'
            },
            {
                type: 'articleListingSection'
            },
            {
                type: 'eventListingSection'
            },
            {
                type: 'jobListingSection'
            },
            {
                type: 'diseaseListingSection'
            },
            {
                type: 'profileListingSection'
            },
            {
                type: 'departmentsSection'
            },
            {
                type: 'researchPlatformListingSection'
            },
            {
                type: 'contactSection'
            },
            {
                type: 'dividerSection'
            },
            {
                type: 'reportsGridSection'
            },
            {
                type: 'donationBoxSection'
            },
            {
                type: 'imageActionCardsSection'
            },
            {
                type: 'legacySimulatorSection'
            }
        ]
    }
}, [
    largeHero.schema.largeHero,
    simpleHero.schema.simpleHero,
    mediaSection.schema.mediaSection,
    keyFiguresSection.schema.keyFiguresSection,
    bigTitleSection.schema.bigTitleSection,
    programsListSection.schema.programsListSection,
    pictureAndContentSection.schema.pictureAndContentSection,
    latestNewsGridSection.schema.latestNewsGridSection,
    logoCarouselSection.schema.logoCarouselSection,
    stepListSection.schema.stepListSection,
    simpleDatalistSection.schema.simpleDatalistSection,
    imageGallerySection.schema.imageGallerySection,
    simpleContentSection.schema.simpleContentSection,
    reportsGridSection.schema.reportsGridSection,
    teamSection.schema.teamSection,
    callToActionCardsGridSection.schema.callToActionCardsGridSection,
    logoCardsGridSection.schema.logoCardsGridSection,
    simpleCardsListSection.schema.simpleCardsListSection,
    researchGroupListingSection.schema.researchGroupListingSection,
    articleListingSection.schema.articleListingSection,
    eventListingSection.schema.eventListingSection,
    jobListingSection.schema.jobListingSection,
    diseaseListingSection.schema.diseaseListingSection,
    profileListingSection.schema.profileListingSection,
    departmentsSection.schema.departmentsSection,
    researchPlatformListingSection.schema.researchPlatformListingSection,
    contactSection.schema.contactSection,
    dividerSection.schema.dividerSection,
    donationBoxSection.schema.donationBoxSection,
    imageActionCardsSection.schema.imageActionCardsSection,
    legacySimulatorSection.schema.legacySimulatorSection
]);
var validator = z.object({
    value: z.array(z.unknown()).refine(function(value) {
        return true;
    })
}).partial();
schema.internationalizedArrayPageSectionsValue;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayPageSectionsValue.js.map